import {
  Button,
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@monksflow/monks-ui';
import { useTranslation } from 'react-i18next';

interface RemoveProviderConfirmationModalProps {
  open: boolean;
  isProcessing: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  affectedProviders: Array<{ key: string; name: string }>;
}

export const RemoveProviderConfirmationModal = ({
  open,
  isProcessing,
  onCancel,
  onConfirm,
  affectedProviders,
}: RemoveProviderConfirmationModalProps) => {
  const { t, i18n } = useTranslation('admin');

  const formatProviderNames = () =>
    new Intl.ListFormat(i18n.language, { type: 'conjunction' }).format(
      affectedProviders.map((p) => `"${p.name}"`),
    );

  return (
    <Dialog
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen && !isProcessing) onCancel();
      }}
    >
      <DialogContent className="max-w-125 gap-0 rounded-3xl p-4" showCloseButton={!isProcessing}>
        <DialogHeader>
          <DialogTitle>{t('admin.removeProviderConfirmationModal.removeProviders')}</DialogTitle>
        </DialogHeader>
        <DialogBody className="flex flex-col gap-4 py-2 text-center">
          <p className="text-base font-medium leading-6 text-foreground">
            {t('admin.removeProviderConfirmationModal.areYouSureYouD')}
          </p>
          <p className="text-base leading-6 text-foreground">
            {t('admin.removeProviderConfirmationModal.modelsAreWhitelisted', {
              count: affectedProviders.length,
              names: formatProviderNames(),
            })}
          </p>
        </DialogBody>
        <DialogFooter>
          <Button type="button" variant="outline" onClick={onCancel} disabled={isProcessing}>
            {t('admin.removeProviderConfirmationModal.cancel')}
          </Button>
          <Button type="button" onClick={onConfirm} disabled={isProcessing}>
            {isProcessing
              ? t('admin.removeProviderConfirmationModal.removing')
              : t('admin.removeProviderConfirmationModal.yesRemove')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

RemoveProviderConfirmationModal.displayName = 'RemoveProviderConfirmationModal';
